<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<h4>Manual Scan Details</h4>

				<div class="DetailsGrid">
					<label>ID Card Status:</label>
					<p>{{ IDCardStatusDesc }}</p>

					<label>Created By:</label>
					<p>{{ Admin_PersonName }}</p>

					<label>Comments:</label>
					<p>{{ ManualComment }}</p>

					<label>New ID Card Printed:</label>
					<p>{{ ReprintCardDesc }}</p>

					<label>Charged For New Card:</label>
					<p>{{ ChargeReprintDesc }}</p>

					<label>Temporary Card Printed:</label>
					<p>{{ PrintedTempDesc }}</p>

					<label>Charged For Temporary Card:</label>
					<p>{{ ChargeTempDesc }}</p>

					<label>Amount Paid:</label>
					<p>{{ PaidAmount }}</p>

					<label>Reprint Fee:</label>
					<p>{{ ReprintFee }}</p>

					<label>Temporary Card Fee:</label>
					<p>{{ TempIDFee }}</p>
				</div>
			</div>
		</div>
	</div>
</div>
